import React from 'react';
import {
  NavLink,
  useLocation,
 } from 'react-router-dom';
import {CBadge} from '@coreui/react-pro';
import {useSelector} from 'react-redux';

const PrivateSidebarNav = ({items}) => {

  const location = useLocation();

  const authorization = useSelector(state => state.auth.authorization);

  const navLink = (name, icon, badge) => {
    return (
      <>
        {icon && icon}
        {name && name}
        {badge && (
          <CBadge color={badge.color} className='ms-auto'>
            {badge.text}
          </CBadge>
        )}
      </>
    );
  }

  const navItem = (item, index) => {

    const {
      component,
      name,
      badge,
      icon,
      employeeRestricted,
      yieldEstimatorOnly,
      ...rest } = item;

    if (yieldEstimatorOnly === false && authorization?.isYieldEstimatorUser === true) {
      return null;
    }

    else if (employeeRestricted === true && authorization?.isEmployee === true) {
      return null;
    }

    const Component = component;

    return (
      <Component
        {...(rest.to && !rest.items && {
          component: NavLink,
        })}
        key={index}
        {...rest}>
        {navLink(name, icon, badge)}
      </Component>
    );
  }

  const navGroup = (item, index) => {

    const {
      component,
      name,
      icon,
      to,
      ...rest } = item;

    const Component = component;

    return (
      <Component
        idx={String(index)}
        key={index}
        toggler={navLink(name, icon)}
        visible={location.pathname.startsWith(to)}
        {...rest}>
        {
          item.items?.map((item, index) => item.items ? navGroup(item, index) : navItem(item, index))
        }
      </Component>
    );
  }

  return (
    <React.Fragment>
      {items && items.map((item, index) => (item.items ? navGroup(item, index) : navItem(item, index)))}
    </React.Fragment>
  )
}

export default PrivateSidebarNav;
